<template>
    <div v-if="isDeleteModalShown">
      <div class="modal-mask" role="dialog">
        <div class="overlay-mask">
          <div class="modal-dialog modal-lg">
              <div class="modal-content modal-delete-bg">
                  <div class="modal-body">
                    <div class="close_btn" v-on:click="CloseModal()"></div>
                    <div class="passwordReset-header">
                        <!-- <p class="modal-title">My Account</p> -->
                        <p class="doctor_title_msg">Are you sure you want to delete this doctor's information from your account?</p>
                    </div>
                    <div class="col-lg-10 offset-lg-1 col-md-12 col-sm-12 col-xs-12 g-mb-10" style="padding: 10px 20px; background-color: whitesmoke">
                      <div>
                        <!--View Doctor Info START-->
                          <div v-for="(doctorItem, index) in AccountView.eyeDoctors">
                            <div class="row" v-if="index == doctorIndex">
                              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="row" v-show="FormInputs.EyeDoctorName">
                                  <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
                                    <label class="doctor_label">Name</label>
                                  </div>
                                  <div class="col-lg-7 col-md-12 col-sm-12 col-xs-12">
                                    <p class="doctor_p">{{doctorItem.firstName + " " + doctorItem.lastName + ", " + doctorItem.suffix}}</p>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
                                    <label class="doctor_label">NPI Number</label>
                                  </div>
                                  <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">
                                    <p class="doctor_p">{{doctorItem.npiNumber}}</p>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
                                    <label class="doctor_label">License Number/State</label>
                                  </div>
                                  <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">
                                    <p class="doctor_p" v-if="doctorItem.licenseNumber && doctorItem.state && doctorItem.useLicenseNumber == true">{{IsEmpty(IsNull(doctorItem.licenseNumber)) + IsNull(doctorItem.state)}}</p>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
                                    <label class="doctor_label">Years in Practice</label>
                                  </div>
                                  <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">
                                    <p class="doctor_p" v-if="doctorItem.yearsInPractice">{{doctorItem.yearsInPractice}} years</p>
                                  </div>
                                </div>
                                <div class="row" v-show="FormInputs.EyeDoctorEmail">
                                  <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
                                    <label class="doctor_label">Doctor's Email Address</label>
                                  </div>
                                  <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">
                                    <p class="doctor_p">{{doctorItem.emailAddress}}</p>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
                                    <label class="doctor_label">Professional Associations</label>
                                  </div>
                                  <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">
                                    <!-- <p class="doctor_p">{{AccountView.organizations.list}}</p> -->
                                    <p class="doctor_p"></p> 
                                  </div>
                                </div>  
                              </div>
                            </div>

                          </div>
                        <!--View Doctor Info END-->
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
                      <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-85 g-mx-10" v-on:click="DeleteDoctor()">Yes</button>
                      <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-85 g-mx-10" v-on:click="CloseModal()">No</button>
                    </div>
                  </div>
              </div>
          </div>
        </div>
      </div>
    </div>       
</template>
<script>
export default {
  props: ['AccountView',
          'FormInputs',
          'Suffix',
          'State',
          'CheckboxIndividual',
          'isFormLoading',
          'AccountValidationResult',
          'eyeDoctorActiveIndex'],
  components: {},
  data() {
    return {
        isDeleteModalShown: true,
        doctorIndex: this.AccountView.eyeDoctorActiveIndex
    }
  },
  methods: {
    CloseModal() {
      this.isDeleteModalShown = false;
      this.$emit("modalClose");
      document.body.classList.remove("body-overflow");
    },
    DeleteDoctor() {
      this.$emit("delete");
    }
  }
}
</script>


// WEBPACK FOOTER //
// DeleteModal.vue?168b7c28